import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.79 14.23c-.62-.62-1.43-.96-2.27-.96H8.61c-.82 0-1.6.32-2.22.91-.45.32-.8.8-.98 1.35-.15.44.1.92.54 1.07.22.07.44.06.65-.04.2-.1.35-.28.43-.49.07-.22.21-.41.38-.52.05-.03.09-.07.14-.11.3-.3.68-.47 1.07-.47h4.91c.39 0 .77.17 1.07.47.17.17.33.42.39.63.07.21.22.39.43.49.12.06.25.09.38.09a.834.834 0 0 0 .76-.47c.1-.2.12-.43.04-.64a3.7 3.7 0 0 0-.8-1.29ZM11 12.33c1.92 0 3.48-1.56 3.48-3.48S12.92 5.37 11 5.37 7.52 6.93 7.52 8.85s1.56 3.48 3.48 3.48m0-5.26c.98 0 1.79.8 1.79 1.78a1.786 1.786 0 0 1-3.57 0c0-.98.8-1.78 1.78-1.78"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 0C4.92 0 0 4.92 0 11s4.92 11 11 11 11-4.92 11-11S17.08 0 11 0m0 20.31c-5.14 0-9.31-4.17-9.31-9.31S5.86 1.69 11 1.69s9.31 4.17 9.31 9.31-4.17 9.31-9.31 9.31"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }